import Maths3 from "oc-threejs/Maths3.js";
import Restraint from "./Restraint.js";
import Scenes from "oc-threejs/Scenes";
import {v3} from "oc-threejs/short3";
import Debugs from "oc-threejs/Debugs";
import AnchorAwareMixin from "./AnchorAwareMixin";
import OcAxisHelper from "oc-threejs/objects/OcAxisHelper";

class PlaneRestraintIntern extends Restraint {
    /**
     * @param {THREE.Ray} ray
     * @returns {?THREE.Vector3}
     */
    raycastLocal(ray) {
        return ray.intersectPlane(this.plane);
    }
}

/**
 * Positioniert das Objekt direkt über einer beliebigen Ebene (default Boden = y-Ebene, oder an einer "Wand").
 * Wenn das Objekt keinen Anchor hat, dann wird das Objekt mit der Unterseite der Boundingbox auf die Ebene gesetzt.
 * Ansonsten wird der Anchor auf die Ebene gesetzt.
 */
export default class PlaneRestraint extends AnchorAwareMixin(PlaneRestraintIntern) {

    /** @type {THREE.Plane} */
    plane;
    // @deprecated synonym für options.freeOrientation
    /** @type {boolean} */
    freeOrientationAroundMainAxis;
    /** @type {THREE.Vector3} */
    defaultAnchorBoxPosition;

    constructor(options = {}) {
        super(options);
        this.plane = options.plane || Maths3.plane.y0;
        this.freeOrientation = options.freeOrientation || options.freeOrientationAroundMainAxis || false;
        this.defaultAnchorBoxPosition = options.defaultAnchorBoxPosition || v3();
    }

    /**
     * @param {THREE.Raycaster} raycaster
     * @param {THREE.Vector3} point
     * @param {boolean} dropped
     */
    perform(raycaster, point, dropped) {
        if (this.freeOrientation) {
            Scenes.bring({
                what: [this.dragObject3d,this.anchorMatrix,v3(0,1,0)],
                to: [this.matrixWorld,this.plane.normal],
                rotate: true,
            });
        } else {
            Scenes.bring({
                what: [this.dragObject3d,this.anchorMatrix],
                to: [this.matrixWorld],
                rotate: true,
            });
        }

        Scenes.bring({
            what: [this.dragObject3d,this.anchorMatrix],
            to: [point],
            translate: true,
        });

    }

    getObjectBox(dragged, box3) {
        let objectBB = new THREE.Box3();
        return objectBB.expandByObject(dragged);
    }

    setDefaultAnchorMatrix() {
        // setze das Objekt mittig auf den Boden
        const position = this.dragObject3dBoundingBoxLocal.grid(0.5,0,0.5);
        const delta = position.sub(this.defaultAnchorBoxPosition);
        console.log('setDefaultAnchorMatrix position: '+position);
        this.anchorMatrix = new THREE.Matrix4().setPosition(delta);
    }

    createDebugVisualization() {
        const group = new THREE.Group();
        group.add(new OcAxisHelper(1));
        const color = STAGE.settings.dragDrop.restraintsDebugColor;
        const grid = new THREE.GridHelper( 10, 50, color, color );
        grid.quaternion.copy(new THREE.Quaternion().setFromUnitVectors(Maths3.vector.y,this.plane.normal));
        group.add(grid);
        return group;
    }

}
